import { BellRing, Building2, Link2, Network, Receipt, ScrollText, TrendingUp } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

export interface NavItem {
  to: string
  labelKey: string
  icon: LucideIcon
}

export const navItems: NavItem[] = [
  { to: '/opportunities', labelKey: 'nav.opportunities', icon: TrendingUp },
  { to: '/properties', labelKey: 'nav.properties', icon: Building2 },
  { to: '/partners', labelKey: 'nav.partners', icon: Network },
  { to: '/links', labelKey: 'nav.links', icon: Link2 },
  { to: '/conversions', labelKey: 'nav.conversions', icon: Receipt },
  { to: '/alerts', labelKey: 'nav.alerts', icon: BellRing },
  { to: '/audit', labelKey: 'nav.audit', icon: ScrollText },
]
